<template>
  <div class="description">
    <div class="description__subtitle">{{ content.name }}</div>
    <div class="description__title">{{ content.title }}</div>

    <div class="description-table">
      <div class="description-table__row">
        <div class="description-table__col">
          <div class="description__property">Этаж</div>
          <div class="description__value">{{ content.floor }}</div>
        </div>
        <div class="description-table__col-2">
          <div class="description__property">Цена</div>
          <div class="description__value">{{ priceOfPenthouse }}</div>
        </div>
        <div class="description-table__col" v-if="isMobile">
          <div class="description__property">{{ content.area[0].name }}</div>
          <div class="description__value">{{ content.area[0].value }}</div>
        </div>
      </div>
      <div class="description-table__row" v-if="isMobile">
        <div class="description-table__col-2" v-if="isMobile">
          <div class="description__property">{{ content.area[1].name }}</div>
          <div class="description__value">{{ content.area[1].value }}</div>
        </div>
        <div class="description-table__col" v-if="isMobile">
          <div class="description__property">{{ content.area[2].name }}</div>
          <div class="description__value">{{ content.area[2].value }}</div>
        </div>
        <div class="description-table__col-2" v-if="isMobile">
          <div class="description__property">{{ content.area[3].name }}</div>
          <div class="description__value">{{ content.area[3].value }}</div>
        </div>
      </div>
      <div class="description-table__row" v-if="isMobile">
        <div class="description-table__col">
          <div class="description__property">Виды</div>
          <div class="description__value" style="text-transform: none">{{ content.views[0] }}</div>
          <div class="description__value" style="text-transform: none">{{ content.views[1] }}</div>
        </div>
      </div>
      <div class="description-table__row" v-if="!isMobile">
        <div class="description-table__col">
          <div class="description__property">{{ content.area[0].name }}</div>
          <div class="description__value">{{ content.area[0].value }}</div>
        </div>
        <div class="description-table__col-2" v-if="!isMobile">
          <div class="line"></div>
          <div class="description__property">{{ content.area[1].name }}</div>
          <div class="description__value">{{ content.area[1].value }}</div>
          <div class="description__property">{{ content.area[2].name }}</div>
          <div class="description__value">{{ content.area[2].value }}</div>
          <div class="description__property">{{ content.area[3].name }}</div>
          <div class="description__value">{{ content.area[3].value }}</div>
        </div>
      </div>
    </div>

    <div class="description__property" v-if="!isMobile">Виды</div>
    <div class="description__value" style="text-transform: none" v-if="!isMobile">{{ content.views[0] }}</div>
    <div class="description__value" style="text-transform: none" v-if="!isMobile">{{ content.views[1] }}</div>

  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: 'DetailedStats',
  props: {
    content: Object
  },
  computed: {
    ...mapState(['penthousesList', 'windowWidth', 'statusesAndPrices']),
    priceOfPenthouse() {
      return this.statusesAndPrices.content && this.statusesAndPrices.content.find(item => item.pentNumber === this.$route.params.pentNumber).priceFull
    },
    isMobile() {
      return this.windowWidth < 1000
    }
  },
  mounted() {
    console.log(this.$route.params.pentNumber)
  }
}
</script>

<style lang="stylus" scoped>
  @import '../styles/tools'
  .description
    display flex
    flex-direction column
    align-items flex-start
    justify-content center
    font-family Roboto,Arial,Helvetica,sans-serif
    text-transform uppercase
    color #fff
    width 100%
    @media (min-width 1000px)
      width-between-property 'min-width' 1000 300 1920 450 true true
      width auto


    &__subtitle
      font-weight 600
      opacity .4
      margin-bottom 10px
      width-between-property 'font-size' 320 15 1000 20 true true
      @media (min-width 1000px)
        width-between-property 'font-size' 1000 17 1920 22 true true


    &__title
      font-family 'Asket Extended'
      font-weight 500
      margin-bottom 30px
      line-height 1.23
      width-between-property 'font-size' 320 22 1000 33 true true
      @media (min-width 1000px)
        width-between-property 'font-size' 1000 22 1920 44 true true
        width-between-property 'margin-bottom' 1000 15 1920 50 true true


    &-table
      margin-bottom 30px
      width 100%


      &__row
        margin-bottom 30px
        display flex
        flex-direction row
        @media (max-width 1000px)
          flex-wrap wrap
          justify-content flex-start
          align-items center
          margin-bottom 20px
          width-between-property 'margin-bottom' 320 5 1000 20 true true


      &__col
        margin 0
        padding 0
        display flex
        flex-direction column
        justify-content center
        @media (min-width 1000px)
          width 50%
        @media (max-width 1000px)
          justify-content space-between
          margin-right 30px
        &-2
          padding-left 15px
          position relative
          @media (min-width 1000px)
            width 50%
          @media (max-width 1000px)
            margin-right 20px
            padding 0
            display flex
            flex-direction column
            justify-content space-between

    &__property
      font-weight 600
      opacity .4
      margin-bottom 10px
      width-between-property 'font-size' 320 9 1000 13 true true
      @media (min-width 1000px)
        width-between-property 'font-size' 1000 10 1920 15 true true
        margin-bottom 15px


    &__value
      font-weight 500
      width-between-property 'font-size' 320 12 1000 18 true true
      line-height 1.12
      margin-bottom 20px
      &:last-child
        @media (min-width 1000px)
          margin-bottom 0
      @media (min-width 1000px)
        width-between-property 'font-size' 1000 15 1920 20 true true


  .description__value + .description__value
      margin-top -15px


  .line
    position absolute
    left -15px
    width 2px
    height 100%
    background-color: #fff
    opacity .4
    @media (max-width 1000px)
      left -5px


  .padding-left
    padding-left 15px
    @media (max-width 1000px)
      padding-left 5px
</style>